class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this._selectTab(index));
      tab.addEventListener('keydown', (event) => this._onKeydown(event, index));
    });
  }

  _onKeydown(event, index) {
    let newIndex;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        newIndex = (index + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        newIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this._selectTab(newIndex);
    this.tabs[newIndex].focus();
  }

  _selectTab(selectedIndex) {
    this.tabs.forEach((tab, index) => {
      const isSelected = index === selectedIndex;

      tab.setAttribute('aria-selected', isSelected);
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      tab.classList.toggle('product-tabs__tab--active', isSelected);

      this.panels[index].hidden = !isSelected;
      this.panels[index].classList.toggle('product-tabs__panel--active', isSelected);
    });
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
